export default __webpack_public_path__ + "static/media/bgHead.382c9b44.png";